module.exports = __webpack_public_path__ + "static/media/logo-costaNorte.a69f1a25.jpg";